import type { Engine } from '../audio/engine';
import type { Scheduler } from '../audio/scheduler';
import type { Store } from '../state/store';
import type { EngineState } from '../types';
import { saveSettings } from '../state/settings';
import { NUM_BAR, NUM_VAR, clamp } from '../constants';

export interface KeyboardHooks {
  openAbout: () => void;
  closeAbout: () => void;
}

export function installKeyboard(
  engine: Engine,
  scheduler: Scheduler,
  store: Store<EngineState>,
  hooks: KeyboardHooks,
): () => void {
  function onKey(e: KeyboardEvent): void {
    const s = store.get();
    switch (e.code) {
      case 'Space':
        e.preventDefault();
        if (scheduler.isRunning()) scheduler.pause();
        else scheduler.resume();
        break;
      case 'KeyL': {
        const v = !s.loop;
        engine.setLoop(v);
        saveSettings({ loop: v });
        break;
      }
      case 'KeyR': {
        const v = !s.linear;
        engine.setLinear(v);
        saveSettings({ linear: v });
        break;
      }
      case 'KeyI': {
        const v = !s.invertPitch;
        engine.setInvertPitch(v);
        saveSettings({ invertPitch: v });
        break;
      }
      case 'ArrowLeft':
        engine.requestJump(clamp(s.playBar - 1, 0, NUM_BAR - 1), s.playVar);
        break;
      case 'ArrowRight':
        engine.requestJump(clamp(s.playBar + 1, 0, NUM_BAR - 1), s.playVar);
        break;
      case 'ArrowUp':
        engine.requestJump(s.playBar, clamp(s.playVar - 1, 0, NUM_VAR - 1));
        break;
      case 'ArrowDown':
        engine.requestJump(s.playBar, clamp(s.playVar + 1, 0, NUM_VAR - 1));
        break;
      case 'Escape':
        engine.clearJump();
        hooks.closeAbout();
        break;
      case 'Slash':
        if (e.shiftKey) hooks.openAbout();
        break;
    }
  }

  window.addEventListener('keydown', onKey);
  return () => window.removeEventListener('keydown', onKey);
}
